import(/* webpackMode: "eager" */ "/opt/buildhome/repo/fronted/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/fronted/components/footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/fronted/components/header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ThemeProvider"] */ "/opt/buildhome/repo/fronted/components/theme-provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LanguageProvider"] */ "/opt/buildhome/repo/fronted/contexts/language-context.tsx");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/fronted/node_modules/.pnpm/next@15.2.4_react-dom@19.1.0_react@19.1.0__react@19.1.0/node_modules/next/font/google/target.css?{\"path\":\"app/layout.tsx\",\"import\":\"Inter\",\"arguments\":[{\"subsets\":[\"latin\"]}],\"variableName\":\"inter\"}");
